import { logger } from '../../../utils/logger';

export type PollOptions = {
  interval: number;
  maxAttempts: number;
  initialDelay: number;
};

export const poll = (checkFn: () => Promise<unknown>, options: Partial<PollOptions>) => {
  const defaultOptions = {
    interval: 1000,
    maxAttempts: 5,
    initialDelay: 0,
  };

  const { interval, maxAttempts, initialDelay } = Object.assign({}, defaultOptions, options);

  const errors: Error[] = [];

  const wait = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

  const attemptPoll = (attempt: number): Promise<unknown> => {
    return checkFn()
      .then(result => {
        return result;
      })
      .catch(err => {
        errors.push(err);
        if (attempt >= maxAttempts) {
          logger.error('Polling failed after max attempts:', errors);
          return Promise.reject(new Error('Max polling attempts reached'));
        }
        return wait(interval).then(() => attemptPoll(attempt + 1));
      });
  };

  return wait(initialDelay).then(() => attemptPoll(0));
};
